import store from "@/store/store";

export const localCurrency = (value) => {
  const currency = store.getters.getCountry.currency ? store.getters.getCountry.currency : "COP";
  const formatter = new Intl.NumberFormat("it-IT", {
    style: "decimal",
    currency: currency,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
  return `$${formatter.format(value)}`;
};
